import {
  DataListTagInfo,
  DataPagination,
  RequestParams,
} from '@robovision/data'
import {
  type DataTag,
  queryOptions,
} from '@tanstack/vue-query'
import { Tag } from '~domain/Tag'
import {
  dataApi,
} from '~services/api'
import { queryClient } from '~services/query-client'
import { RETHROW_ERROR_AFTER_HANDLING } from '~utils/api/error-handling'


type ListFilteredPoolTagsQuery = Parameters<typeof dataApi.pools.listFilteredPoolTags>[1]

type ListFilteredPoolTagsParams = Omit<RequestParams, 'signal' | 'validateStatus'>
  & { signal?: AbortSignal }

function listFilteredPoolTagsQueryKey (poolId: string, query: DataListTagInfo) {
  const {
    pagination,
    ...filters
  } = query

  return [
    'dataApi',
    'pools',
    'listFilteredPoolTags',
    poolId,
    filters,
    pagination,
  ] as DataTag<unknown[], {
    nextPagination: DataPagination
    tags: Tag[]
  }>
}

export function listFilteredPoolTagsQueryOptions (
  poolId: string,
  query: ListFilteredPoolTagsQuery,
  params?: ListFilteredPoolTagsParams,
) {
  return queryOptions({
    queryFn: ({ signal }) => dataApi.pools.listFilteredPoolTags(poolId, query, {
      ...RETHROW_ERROR_AFTER_HANDLING,
      ...params,
      signal: params?.signal ? AbortSignal.any([signal, params.signal]) : signal,
    })
      .then(response => {
        const {
          tags,
          nextPagination,
        } = response.data

        return {
          tags: tags.map(Tag.fromResponse),
          nextPagination,
        }
      }),
    queryKey: listFilteredPoolTagsQueryKey(poolId, query),
  })
}

export function listFilteredPoolTags (
  poolId: string,
  query: ListFilteredPoolTagsQuery,
  params?: ListFilteredPoolTagsParams,
) {
  return queryClient.fetchQuery(listFilteredPoolTagsQueryOptions(poolId, query, params))
}
